import { records as userRecords } from '@saucelabs/sl-module-user';

export const selectUser = (store) => store.apps.jobs.users.get('user') as userRecords.UserRecord;
